import { LitElement, html, unsafeCSS } from "lit-element"
import { styleMap } from "lit-html/directives/style-map"
import { classMap } from "lit-html/directives/class-map"

import commonStyle from "../common.css"
import style from "./nav.css"

export default class extends LitElement {
	static styles = [unsafeCSS(style), unsafeCSS(commonStyle)]
	static get properties () {
		return {
			show: { type: Boolean },
			right: { type: Boolean }
		}
	}

	constructor () {
		super()
		this.show = false
		this.right = false
	}

	/**
	 * @type {HTMLElement}
	 */
	#modalEl = null

	render () {
		return html`
			<bui-modal @modal-hide="${this.hideNav}"></bui-modal>
			<nav class=${this.navClass} style=${this.navStyle}>
				<slot></slot>
			</nav>
		`
	}

	firstUpdated () {
		this.#modalEl = this.shadowRoot.querySelector("bui-modal")
	}

	set show (value) {
		if (this.show === value) return
		if (value) {
			this.#modalEl.show()
		} else {
			this.#modalEl.hide()
		}
		this.requestUpdate()
	}

	get show () {
		return this.#modalEl ? this.#modalEl.isShow : false
	}

	get navClass () {
		return classMap({
			nav: true,
			"overlay-shadow": true,
			surface: true,
			"is-show": this.show,
			"is-right": this.right,
			"is-left": !this.right
		})
	}

	get navStyle () {
		return styleMap({
			"z-index": this.#modalEl ? this.#modalEl.actualZIndex : ""
		})
	}

	hideNav () {
		this.requestUpdate()
		this.dispatchEvent(new CustomEvent("hide-nav"))
	}
}
